import { Component, OnInit, ViewChild, Input, Output, ElementRef, EventEmitter, ViewContainerRef, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { FormArray, FormBuilder, FormGroup, Validators, AbstractControl, FormControl, ReactiveFormsModule, FormsModule, } from '@angular/forms';
import { Router, ActivatedRoute } from '@angular/router';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { DialogOverviewExampleDialogComponent } from '../../dialog-overview-example-dialog/dialog-overview-example-dialog.component';
import { BackendApiService } from '../../../app/services/backend-api.service';
import { ValidationService } from '../../../app/validation.service';
import { BaseUrlConstantsService } from '../../../app/services/base-url-constants.service';
import { ChangeUsersService } from '../../../app/services/change-users.service';
import { FileUploader, FileSelectDirective } from 'ng2-file-upload';
import { UploadService } from '../../../app/shared/upload.service';
import { Subscription } from 'rxjs-compat/Subscription';
import { HttpClientModule, HttpClient, HttpRequest, HttpResponse, HttpEventType } from '@angular/common/http';
import { COMMA, ENTER } from '@angular/cdk/keycodes';
import { MatAutocompleteSelectedEvent, MatAutocomplete } from '@angular/material/autocomplete';
import { MatChipInputEvent } from '@angular/material/chips';
import { Observable } from 'rxjs';
import { map, startWith } from 'rxjs/operators';
import * as moment from 'moment-timezone';
import { ConvertDatetimePipe } from '../../../app/convert-datetime.pipe';
import { CommonModule } from '@angular/common';
import { MatButtonModule } from '@angular/material/button';
// import { Ng2TelInput, Ng2TelInputModule } from 'ng2-tel-input';
import { ControlMessagesComponent } from '../../../app/control-messages.component';
// import { NgxMatIntlTelInputComponent } from 'ngx-mat-intl-tel-input';
// import { Injectable } from '@angular/core';
@Component({
  selector: 'app-add-users',
  templateUrl: './add-users.component.html',
  styleUrls: ['./add-users.component.scss'],
  standalone:true,
  imports:[CommonModule,ReactiveFormsModule,ControlMessagesComponent,MatButtonModule,FormsModule],
  schemas:[CUSTOM_ELEMENTS_SCHEMA]
})


export class AddUsersComponent implements OnInit {
  @ViewChild('groupInput', { static: false }) groupInput: ElementRef<HTMLInputElement>;
  @ViewChild('auto', { static: false }) matAutocomplete: MatAutocomplete;
  @ViewChild('myDiv', { static: false }) myDiv: ElementRef;
  @ViewChild('dropDiv', { static: false }) dropDiv: ElementRef;
  public imageBaseV2Url = BaseUrlConstantsService.NEW_IMAGE_RELATIVE_BASE_URL;
  public imageBaseUrl = BaseUrlConstantsService.IMAGE_RELATIVE_URL + 'uploads/';
  public registerUserUrl = BaseUrlConstantsService.REGISTER_USERS;
  private allSitesUrl = BaseUrlConstantsService.GET_SITES;
  private getApplicationsUrl = BaseUrlConstantsService.GET_APPLICATION;
  public imageUploadUrl = BaseUrlConstantsService.IMAGE_UPLOAD;
  public imageUpdateInfoUrl = BaseUrlConstantsService.UPDATE_IMAGE_INFO;
  public editUserUrl = BaseUrlConstantsService.EDIT_USER_INFO;
  public associateSite = BaseUrlConstantsService.ASSOCIATE_SITE_USER;
  public productListingUrl = BaseUrlConstantsService.PRODUCTLIST;
  public getClientProductsUrl = BaseUrlConstantsService.CLIENTS_PRODUCTS;
  public separatorKeysCodes: number[] = [ENTER, COMMA];
  public GroupCtrl = new FormControl();
  defaultFlgONphone: string;
  public filteredGroups: Observable<string[]>;
  public Groups: string[] = [];
  public allGroups: string[] = ['Group1', 'Group2', 'Group3', 'Group4', 'Group5'];
  public uploader: FileUploader;
  public options: FormGroup;
  public uForm: FormGroup;
  public visible = true;
  public selectable = true;
  public removable = true;
  public addOnBlur = true;
  public countryNames: any;
  public countryname: any;
  public maxLength = 0;
  public allCitys: any;
  public pageRef: any;
  public selectedCountry: any;
  public showUpdateBtn: boolean;
  public showEditUsertxt: string;
  public showViewLicense: boolean;
  public states: any = [];
  public showSavebtn: boolean;
  public title = 'Upload a File';
  public url: any;
  public userId: any;
  public id: any;
  public showCancelBtn: boolean;
  public managerList: any;
  public _userId: any;
  public updateDataReq: any = false;
  public _clientSiteId: any;
  public percentDone = 0;
  public selectedOption: any;
  public uploadSuccess: boolean;
  public _imgUrl: any = "./assets/img-new/default_user.png";
  public form: FormGroup;
  public error: string;
  public sitesList: any = [];
  public clientId: any;
  public groupList: any = [];
  public associatedSites: any = [];
  public associatedApplications: any = [];
  public showEnabledSaveBtn = true;
  public showDisabledSaveBtn: boolean;
  public fileName: string = '';
  public _imageId = null;
  public imagePath;
  today: any;
  imgURL: any;
  public editShowDiv: boolean;
  public timeZones: any = [];
  public invoiceForm: FormGroup;
  public breadcrumbsArray: any = [
    'users',
    'add-user'
  ];
  public company_name: any;
  public productBoxList: any =[];
  public clientProducts: any;
  public productBoxListData: any =[];
  public userRoll: string;
  productsList: any;
  constructor(
    public router: Router,
    private http: HttpClient,
    private uploadService: UploadService,
    private service: BackendApiService,
    private changeService: ChangeUsersService,
    public activeRoute: ActivatedRoute,
    public dialog: MatDialog,
    private formBuilder: FormBuilder) {
    this.company_name = localStorage.getItem('company_name');
    this.userRoll = localStorage.getItem('role');
    this.utcTime();
    this.uploader = new FileUploader({ url: BaseUrlConstantsService.IMAGE_UPLOAD, itemAlias: 'photo' });
    this.filteredGroups = this.GroupCtrl.valueChanges.pipe(
      startWith(null),
      map((Group: string | null) => Group ? this._filter(Group) : this.groupList.slice())
    );

    activeRoute.queryParams.subscribe(params => {
      this._userId = params[`userId`];
      this.countryname = params['countryname'];
      switch (this.countryname) {
        case 'Canada':
          this.countryname = 'ca';
          break;
        case 'India':
          this.countryname = 'in';
          break;
        case 'United States':
          this.countryname = 'us';
          break;
      }
      this.pageRef = params[`pageRef`];
      if (this.pageRef === `admin-user`) {
        this.showUpdateBtn = true;
        this.showEditUsertxt = 'Edit User';
        this.showViewLicense = true;
        this.editShowDiv = true;
        this.showSavebtn = false;
      } else {
        this.getProductList();
        this.showUpdateBtn = false;
        this.showSavebtn = true;
        this.editShowDiv = false;
        this.showEditUsertxt = 'Create User';
        this.showViewLicense = false;
      }
    });
  }

  utcTime() {
    setInterval(() => {
      const date = new Date().getHours();
      const houre = new Date().getMinutes();
      const second = new Date().getSeconds();
      this.today = new ConvertDatetimePipe().convertDateTime(new Date());
    }, 1000);
  }

  goToPageLink(name: string) {
    this.router.navigate([name]);
  }

  public noWhitespaceValidator(control: FormControl) {
    const isWhitespace = (control.value || '').trim().length === 0;
    const isValid = !isWhitespace;
    return isValid ? null : { 'whitespace': true };
  }

  removeUserImage() {
    this.service.getData(this.imageUploadUrl + "/remove/" + this._userId).then(response => {
      this._imgUrl = "./assets/img-new/default_user.png";
      this.service.showSuccess('Removed successfully.');
    });
  }

  ngOnInit() {
    console.log("skjdskd")
    this.timeZones = moment.tz.names();
    this.invoiceForm = this.formBuilder.group({
      itemRows: this.formBuilder.array([this.initItemRows()])
    });

    this.updateDataReq = false;
    this.form = this.formBuilder.group({
      avatar: ['']
    });

    this.uForm = this.formBuilder.group({
      full_name: new FormControl('', [Validators.required, this.noWhitespaceValidator]),
      email: new FormControl('', ValidationService.emailValidator),
      phone_number: new FormControl('', [Validators.pattern(/^(\+\d{1,3}[- ]?)?\d{10}$/)]),
      address_line1: new FormControl('', [Validators.required, this.noWhitespaceValidator]),
      address_line2: new FormControl(''),
      country_name_: new FormControl(''),
      state_name: new FormControl(''),
      city_name: new FormControl('', [Validators.required, this.noWhitespaceValidator]),
      postcode: new FormControl('', [Validators.required, this.noWhitespaceValidator]),
      number_of_license: new FormControl(''),
      timezone: new FormControl('', [Validators.required, this.noWhitespaceValidator]),
    });
    this.service.load().then(data => {
      this.countryNames = JSON.parse(JSON.stringify(data)).countries;
    });
    if (this._userId !== undefined) {
      this.getUserData();
    }
    this.uploader.onBuildItemForm = (item, form) => {
      form.append('token', localStorage.getItem('token'));
      form.append('user_id', this._userId);
    };
    this.uploader.onAfterAddingFile = (file) => { file.withCredentials = false; };
    this.uploader.onCompleteItem = (item: any, response: any, status: any, headers: any) => {
      if (status === 200) {
        this.service.getData(this.imageUploadUrl + "/" + this._userId).then(response => {
          if (JSON.parse(JSON.stringify(response)).data.body.length !== 0) {
            this._imgUrl = this.imageBaseV2Url + JSON.parse(JSON.stringify(response)).data.body[0].relative_url;
            this.fileName = '';
            this.service.showSuccess('Saved successfully');
          }
        });
      } else {
        this.service.showError('Upload unsuccessfully');
      }
    };
    this.showProfileImage();
  };

//get product check api

getCheckedProduct(){
  this.service.getClientProductByID(this.getClientProductsUrl+ "/" +  Math.floor(Math.random() * 90 + 10) + localStorage.getItem('user_id') + Math.floor(Math.random() * 9000 + 1000)).then((res) => {

    const parsedRes = JSON.parse(JSON.stringify(res));
    console.log(parsedRes.data.body.body,'parsedRes.data.body.body')
        this.productsList = parsedRes.data.body.body.map(item => item.product_type_id).join(',');

    if (parsedRes.data.status === 'success') {
       this.productBoxList = this.productBoxListData.filter((item) =>{
         return parsedRes.data.body.body.some((element) => {
            return item.id == element.product_type_id;
          });
       });
       console.log(this.productBoxList,'produclist',this.productsList);
    } else {
        this.service.showError('Something went wrong.');
    }

  });
}

//get product list
getProductList(){
  this.service.getProductType(this.productListingUrl).then((res) => {
    let response = JSON.parse(JSON.stringify(res)).data;
    if (response.status === 'success') {
      this.productBoxListData = response.body.body;
      this.getCheckedProduct();
    } else {
      this.service.showError('Something went wrong.');
    }

  });
}
  showProfileImage() {
    this.service.getData(this.imageUploadUrl + "/" + this._userId).then(response => {
      console.log('show profile imh: ', response)
      if (JSON.parse(JSON.stringify(response)).data.body.length !== 0) {
        this._imgUrl = this.imageBaseV2Url + JSON.parse(JSON.stringify(response)).data.body[0].relative_url;
      }
    });
  }

  get formArr() {
    return this.invoiceForm.get('itemRows') as FormArray;
  }

  initItemRows() {
    return this.formBuilder.group({
      associate_site: ['']
    });
  }

  addNewRow(idx) {
    this.formArr.push(this.initItemRows());
  }

  deleteRow(index: number) {
    this.formArr.removeAt(index);
  }


  getUserData() {
    console.log('getUserData')
    this.getProductList();
    this.updateDataReq = true;
    const body = {
      id: this._userId
    };
    this.changeService.loader(true);
    this.service.getData(this.editUserUrl + "/" + Math.floor(Math.random() * 90 + 10) + this._userId + Math.floor(Math.random() * 9000 + 1000)).then(response => {
      this.changeService.loader(false);
      if (JSON.parse(JSON.stringify(response)).data.status === 'success') {
        const resp = JSON.parse(JSON.stringify(response)).data.body[0];
        console.log('respppp:', resp)
        if (resp.country == 'Canada' || resp.country == 'United States') {
          console.log(typeof resp.country, 'country')
          resp.phone_no = resp.phone_no.slice(2);
        } else if (resp.country == 'India') {
          resp.phone_no = resp.phone_no.slice(3);
        }
        if (resp.image != null && resp.image.length > 1) {
          this._imgUrl = resp.image;
        }
        this._imageId = resp.image_id;
        this.associatedSites = resp.sites;
        this.onChange(resp.country);
        this.uForm = this.formBuilder.group({
          full_name: new FormControl(resp.full_name, [Validators.required, this.noWhitespaceValidator]),
          email: new FormControl(resp.email, ValidationService.emailValidator),
          phone_number: new FormControl(resp.phone_no, [Validators.pattern(/^(\+\d{1,3}[- ]?)?\d{10}$/)]),
          address_line1: new FormControl(resp.address_1, [Validators.required, this.noWhitespaceValidator]),
          address_line2: new FormControl(resp.address_2),
          country_name_: new FormControl(resp.country),
          state_name: new FormControl(resp.state),
          city_name: new FormControl(resp.city, [Validators.required, this.noWhitespaceValidator]),
          postcode: new FormControl(resp.postal_code, [Validators.required, this.noWhitespaceValidator]),
          timezone: new FormControl(resp.timezone, [Validators.required, this.noWhitespaceValidator]),
          number_of_license: new FormControl(''),
        });
      } else {
        this.service.showError('Something went wrong.');
      }
    });
  }

  getallSitesAndGroupsInfo() {
    this.changeService.loader(true);
    this.service.getData(this.allSitesUrl + "/" + Math.floor(Math.random() * 90 + 10) + localStorage.getItem('user_id') + Math.floor(Math.random() * 9000 + 1000)).then(res => {
      this.changeService.loader(false);
      if (JSON.parse(JSON.stringify(res)).data.status === 'success') {
        this.sitesList = JSON.parse(JSON.stringify(res)).data.body;
      }
    });
  }

  getGroupsBySiteId(id) {
    this.associateSiteUser(id);
    const body = {
      client_id: localStorage.getItem('user_id'),
      site_id: id
    };
    this.changeService.loader(true);
    this.service.postData(this.getApplicationsUrl, body).then(res => {
      this.changeService.loader(false);
      if (JSON.parse(JSON.stringify(res)).data.status === 'success') {
        this.groupList = JSON.parse(JSON.stringify(res)).data.body;
      }
    });
  }

  associateSiteUser(id) {
    this._clientSiteId = id;
    const body = {
      user_id: this._userId,
      client_site_id: id
    };
    this.changeService.loader(true);
    this.service.postData(this.associateSite, body).then(res => {
      this.changeService.loader(false);
      const resp = JSON.parse(JSON.stringify(res)).data;
      if (resp.status === 'success') {
        this.associatedSites.push({ client_site_id: resp.body.client_site_id, id: resp.body.id });
      }
    });
  }


  associateGroup(id) {
    const body = {
      user_id: this._userId,
      client_site_id: this._clientSiteId,
      client_application_id: id
    };
    this.changeService.loader(true);
    this.service.postData(this.associateSite, body).then(res => {
      this.changeService.loader(false);
      const resp = JSON.parse(JSON.stringify(res)).data;
      if (resp.status === 'success') {
        this.associatedApplications.push({ client_application_id: id, id: resp.body.id });
      }
    });
  }

  async saveUserMethod() {
    let _imgId = null;
    if (this.uploadSuccess) {
      _imgId = this.id;
    } else if (this._imageId != null) {
      _imgId = this._imageId;
    }

    let reqObj = {
      client_id: localStorage.getItem('user_id'),
      full_name: this.uForm.value.full_name,
      phone_no: this.uForm.value.phone_number,
      address_1: this.uForm.value.address_line1,
      address_2: this.uForm.value.address_line2,
      country: this.uForm.value.country_name_,
      state: this.uForm.value.state_name,
      city: this.uForm.value.city_name,
      postal_code: this.uForm.value.postcode,
      email: this.uForm.value.email,
      timezone: this.uForm.value.timezone,
      role: 'user',
      client_products: this.productsList
    }
    if (_imgId != null) {
      reqObj['image_id'] = _imgId;
    }
    if (reqObj.country == 'Canada' || reqObj.country == 'United States') {
      reqObj.phone_no = '+1' + reqObj.phone_no;
    } else if (reqObj.country == 'India') {
      reqObj.phone_no = '+91' + reqObj.phone_no;
    }
    if (this.showEditUsertxt === 'Create User') {
      if (this.uForm.dirty && this.uForm.valid) {
        const body = reqObj;
        this.showDisabledSaveBtn = true;
        this.showEnabledSaveBtn = false;
        this.changeService.loader(true);
        this.service.postData(this.registerUserUrl, body).then(res => {
          this.showDisabledSaveBtn = false;
          this.showEnabledSaveBtn = true;
          this.changeService.loader(false);
          console.log("ppppppppppppppppp");
          console.log(JSON.parse(JSON.stringify(res)));
          console.log(JSON.parse(JSON.stringify(res)).data.status);
          if (JSON.parse(JSON.stringify(res)).data.status === 'fail') {
            const msgErr = JSON.parse(JSON.stringify(res)).data.body.message;
            this.service.showError(msgErr);
          } else if (JSON.parse(JSON.stringify(res)).data.status === 'success') {
            if (this.fileName !== '') {
              this._userId = JSON.parse(JSON.stringify(res)).data.user_id;
              this.fileName;
              this.uploader.clearQueue();
              this.uploader.addToQueue(Array.from(this.imagePath)); // ✅ Fixed here
              this.uploader.uploadAll();
                  // this.imagePath
              this.uploader.onProgressItem = (progress: any) => {
                this.percentDone = progress['progress'];
                console.log(this.percentDone);
                console.log("NO FILE ELSEBLOCK");
                if (this.percentDone === 100) {
                  this.service.showSuccess('User registered successfully');
                  this.router.navigate(['/users']);
                }
              };
            } else {
              console.log("NO FILE ELSEBLOCK");
              this.service.showSuccess('User registered successfully');
              this.router.navigate(['/users']);
            }

          } else if (JSON.parse(JSON.stringify(res)).data.body.code === 'ER_DUP_ENTRY') {
            this.service.showError('User already Exists!!');
          }
          else {
            this.service.showError('Something went wrong.');
          }
        });
      }
    } else {

      var reqObject = {
        full_name: this.uForm.value.full_name,
        phone_no: this.uForm.value.phone_number,
        address_1: this.uForm.value.address_line1,
        address_2: this.uForm.value.address_line2,
        country: this.uForm.value.country_name_,
        state: this.uForm.value.state_name,
        city: this.uForm.value.city_name,
        postal_code: this.uForm.value.postcode,
        email: this.uForm.value.email,
        timezone: this.uForm.value.timezone,
        role: 'user',
        client_products: this.productsList
      }
      if (_imgId != null) {
        reqObject['image_id'] = _imgId;
      }
      if (reqObj.country == 'Canada' || reqObj.country == 'United States') {
        reqObject.phone_no = '+1' + reqObject.phone_no;
      } else if (reqObj.country == 'India') {
        reqObject.phone_no = '+91' + reqObject.phone_no;
      }
      const body = reqObject;
      this.showDisabledSaveBtn = true;
      this.showEnabledSaveBtn = false;
      this.changeService.loader(true);
      console.log(this.editUserUrl + "/" + this._userId, body);
      this.service.putData(this.editUserUrl + "/" + (Math.floor(Math.random() * 90 + 10) + this._userId + Math.floor(Math.random() * 9000 + 1000)) , body).then(res => {
        this.showDisabledSaveBtn = false;
        this.showEnabledSaveBtn = true;
        this.changeService.loader(false);
        console.log('dsdfsdfsf', res)
        if (JSON.parse(JSON.stringify(res)).data.status === 'fail') {
          const msgErr = JSON.parse(JSON.stringify(res)).data.body.message;
          this.service.showError("msgErr");
        } else if (JSON.parse(JSON.stringify(res)).data.status === 'success') {
          this.service.showSuccess('User updated successfully');
          this.router.navigate(['/users']);
        } else if (JSON.parse(JSON.stringify(res)).data.body.code === 'ER_DUP_ENTRY') {
          this.service.showError('User already Exists!!');

        } else {
          this.service.showError('Something went wrong.');
        }
      });
    }
  }


  onChange(deviceValue) {
    let pullIndex;
    this.selectedCountry = deviceValue;
    if (deviceValue === 'Canada') {
      pullIndex = 1;
      this.maxLength = 6;
    } else if (deviceValue === 'United States') {
      pullIndex = 0;
      this.maxLength = 5;
    } else {
      pullIndex = 2;
      this.maxLength = 6;
    }
    this.service.load().then(data => {
      this.states = JSON.parse(JSON.stringify(data)).countries[pullIndex].states;
    });
  }

  addClient() {
    this.router.navigate(['/add-user']);
  }

  showLicense(): void {
    const dialogRef = this.dialog.open(DialogOverviewExampleDialogComponent, {
      width: '650px',
      data: {
        type: 'adminLicense',
      }
    });
    dialogRef.afterClosed().subscribe(result => {

    });
  }

  goToPrevious() {
    this.router.navigate(['/users']);
  }

  saveCollection() {
    const navigationExtras = {
      skipLocationChange: true,
      queryParams: {
        pid: true
      }
    };
    this.router.navigate(['/clients'], navigationExtras);
  }


  upload(files: any) {
    if (files[0].name !== undefined && files[0].name === '') {
      this.fileName = '';
    } else {
      this.showCancelBtn = true;
      this.fileName = files[0].name;

      if (this.showEditUsertxt !== 'Create User') {
        this.uploader.clearQueue();
        this.uploader.addToQueue(Array.from(files)); // ✅ Fixed here
        this.uploader.uploadAll();
        this.uploader.onProgressItem = (progress: any) => {
          this.percentDone = progress['progress'];
        };
      } else {
        var reader = new FileReader();
        this.imagePath = files;
        reader.readAsDataURL(files[0]);
        reader.onload = (_event) => {
          this._imgUrl = reader.result;
          console.log("IN CREATE USER CASE ");
          console.log(this.imagePath);
          console.log(this._imgUrl);

        }
      }
    }
  }

  private subscription: Subscription = new Subscription();
  uploadAndProgress(files: any, signedRequest, imageurl, userId, cId) {
    const formData = new FormData();
    this.subscription.add(this.http.put(signedRequest, files[0], { reportProgress: true, observe: 'events' })
      .subscribe(event => {
        if (event.type === HttpEventType.UploadProgress) {
          this.percentDone = Math.round(100 * event.loaded / event.total);
        } else if (event instanceof HttpResponse) {
          this.showCancelBtn = false;
          this.fileName = '';
          this.uploadSuccess = true;
          this._imgUrl = imageurl;
        }
      }));
  }

  cancelClick() {
    this.subscription.unsubscribe();
    this.fileName = '';
    this.showCancelBtn = false;
  }

  add(event: MatChipInputEvent): void {
    if (!this.matAutocomplete.isOpen) {
      const input = event.input;
      const value = event.value;
      if ((value || '').trim()) {
        this.Groups.push(value.trim());
      }
      if (input) {
        input.value = '';
      }
      this.GroupCtrl.setValue(null);
    }
  }

  remove(Group: string): void {
    this.removeApplication(Group);
    const index = this.Groups.indexOf(Group);
    if (index >= 0) {
      this.Groups.splice(index, 1);
    }
  }

  selected(event: MatAutocompleteSelectedEvent, idx): void {
    this.Groups.push(event.option.viewValue);
    this.groupInput.nativeElement.value = '';
    this.GroupCtrl.setValue(null);
  }

  private _filter(value: string): string[] {
    const filterValue = value.toLowerCase();
    return this.groupList.filter(Group => Group.name.toLowerCase().indexOf(filterValue) === 0);
  }
  onCountryChange(num) {

  }
  removeApplication(name) {
    let groupData = this.groupList.filter(data => data.name == name);
    let applicationData = this.associatedApplications.filter(data => data.client_application_id == groupData.id);
    let app_Id = applicationData[0].id;
    const body = {
      id: app_Id,
      mode: "application",
    };
    this.changeService.loader(true);
    this.service.deleteData(this.associateSite, body).then(res => {
      this.changeService.loader(false);
      let resp = JSON.parse(JSON.stringify(res)).data;
      if (resp.status === 'success') {
      }
    });
  }

  removeSite() {
    let sId = this.selectedOption;
    let siteData = this.associatedSites.filter(data => data.client_site_id == sId);
    let site_Id = siteData[0].id;
    const body = {
      id: site_Id,
      mode: "site",
    };
    this.changeService.loader(true);
    this.service.deleteData(this.associateSite, body).then(res => {
      this.changeService.loader(false);
      let resp = JSON.parse(JSON.stringify(res)).data;
      if (resp.status === 'success') {
      }
    });
  }
}






